// Copyright 2023 The Chromium Authors. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.

import * as CPUProfileDataModel from './CPUProfileDataModel.js';
import * as ProfileTreeModel from './ProfileTreeModel.js';

export {
  CPUProfileDataModel,
  ProfileTreeModel,
};
